import { getAppConfig } from "services/configService";

const apiUrl = () => {
  return getAppConfig().Logging.SumoLogicUrl + getAppConfig().Logging.HTTPCollectorCode;
};

export const logToSumoLogic = async payload => {
  if (!getAppConfig()) return;

  const options = {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/json",
      "X-Sumo-Name": "Http Input",
      "X-Sumo-Host": navigator.userAgent,
      "X-Sumo-Category": getAppConfig().Logging.Category
    }),
    mode: "cors",
    responseType: "application/json",
    cache: "default",
    body: JSON.stringify(payload)
  };
  return fetch(apiUrl(), options);
};
